import { render, staticRenderFns } from "./CommonBooking.vue?vue&type=template&id=6c759b5a"
import script from "./CommonBooking.vue?vue&type=script&lang=js"
export * from "./CommonBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c759b5a')) {
      api.createRecord('6c759b5a', component.options)
    } else {
      api.reload('6c759b5a', component.options)
    }
    module.hot.accept("./CommonBooking.vue?vue&type=template&id=6c759b5a", function () {
      api.rerender('6c759b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/CommonBooking.vue"
export default component.exports